import React from 'react';

import { withTimerangeIntelligence } from '../../../shared/containers/containerTimerangeIntelligence'

import TimeRangeIntelligenceTabs from './timeRangeIntelligenceTabs'

import { states } from '../../../reducers/queriesStates'

import styles from './intelligenceInTimeRangeContent.module.scss'

const IntelligenceInTimeRangeContent = props => {
  const { timerangeIntelligenceState } = props

  return (
    <div className={styles.intellegenceTimeRangeContent}>
      {
        timerangeIntelligenceState !== states.NOT_REQUESTED
          ? <TimeRangeIntelligenceTabs disabled={timerangeIntelligenceState === states.REQUEST ? true : false} />
          : null
      }
    </div>
  )
}

export default withTimerangeIntelligence(React.memo(IntelligenceInTimeRangeContent))